import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Button } from "antd";
import { SearchOutlined, ReadOutlined, BarChartOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const TermosRelatorio = () => {
  const { id_termo } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // ID ALTERAÇÃO
  const [search, setSearch] = useState("");

  // DADOS
  const [termo, setTermo] = useState({});

  useEffect(() => {
    if (id_termo > 0) {
      carregarTermo(id_termo);
      listarRelatorio(id_termo);
    }
  }, [id_termo]);

  // CARREGAR
  const carregarTermo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/termos/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setTermo(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarRelatorio = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/termos/relatorio/${id}`, []);
    if (api.statusCode === 200) {
      api.response.data && setDados(api.response.data);
    } else {
      navigate("/termos/cadastro");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Filial",
      dataIndex: "filial",
      sorter: (a, b) => a.filial?.localeCompare(b.filial),
    },
    {
      title: "Total",
      dataIndex: "total",
      sorter: (a, b) => a.total?.toString()?.localeCompare(b.total?.toString()),
    },
    {
      title: "Confirmados",
      dataIndex: "confirmados",
      sorter: (a, b) => a.confirmados?.toString()?.localeCompare(b.confirmados?.toString()),
    },
    {
      title: "Não Confirmados",
      dataIndex: "n_confirmados",
      sorter: (a, b) => a.n_confirmados?.toString()?.localeCompare(b.n_confirmados?.toString()),
    },
    {
      title: "Aguardando",
      dataIndex: "aguardando",
      sorter: (a, b) => a.aguardando?.toString()?.localeCompare(b.aguardando?.toString()),
    },
    {
      title: "",
      width: 50,
      render: (_, e) => (
        <Space.Compact>
          <Button
            loading={loading}
            onClick={() => navigate(`/termos/relatorio/${id_termo}/detalhes/${e?.id}`)}
            icon={<UnorderedListOutlined />}
          />
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.filial?.toLowerCase().includes(pesquisar.toLowerCase()));
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Configurações" onClickBack={() => navigate("/termos/cadastro")} />
            <HeaderTitle
              title="Relatório Termos de Ciência"
              subtitle={
                <Text italic>
                  <ReadOutlined /> {termo?.descricao ?? ""}
                </Text>
              }
              icon={<BarChartOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                summary={() => {
                  let t_total = 0;
                  let t_confirmados = 0;
                  let t_n_confirmados = 0;
                  let t_aguardando = 0;

                  dados?.forEach(({ total, confirmados, n_confirmados, aguardando }) => {
                    t_total += parseInt(total);
                    t_confirmados += parseInt(confirmados);
                    t_n_confirmados += parseInt(n_confirmados);
                    t_aguardando += parseInt(aguardando);
                  });

                  return (
                    <Table.Summary.Row style={{ backgroundColor: "#f7f7f7" }}>
                      <Table.Summary.Cell index={0}>
                        <Text strong>Total</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1}>
                        <Text strong>{t_total}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2}>
                        <Text strong>{t_confirmados}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3}>
                        <Text strong>{t_n_confirmados}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4}>
                        <Text strong>{t_aguardando}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={5} />
                    </Table.Summary.Row>
                  );
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
